export default "__VITE_ASSET__BscW0rAq__"